module.exports = __webpack_public_path__ + "img/img_industries1.2789d0d6.jpg";